import { useState, useEffect } from 'react';
import { contentCount } from 'Api/courseDetailsMain';

const useFetch = courseId => {
  const [contentCountValue, setContentCountValue] = useState();

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      contentCount(courseId).then(data => {
        setContentCountValue(data);
      });
    }

    return () => {
      isMounted = false;
      setContentCountValue(null);
    };
  }, [courseId]);

  return { contentCountValue };
};

export default useFetch;
